import lazyWithRetry from "../../../utils/lazyWithRetry";

const AnalyticsPatients = lazyWithRetry(() =>
  import("./AnalyticsPatients/AnalyticsPatients")
);

export { AnalyticsPatients };
